export default __webpack_public_path__ + "static/media/job_offer6_xl.e7a99ea9.jpg";